<template>
  <div class="index_login">
    <div class="anlan-logo">
      <img src="/static/imgs/anlan-logo.png"/>
    </div>
    <div class="login_form">
      <el-row style="margin-bottom:3vh;">
        <el-col :span="24">
          <h2 style="color:white;font-size:1.8rem;letter-spacing:.1rem;">安蓝航运智能助手</h2>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-input suffix-icon="el-icon-phone" v-model="phone"><template slot="prepend">手机账号</template></el-input>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-input placeholder="请输入密码" v-model="password" show-password><template slot="prepend">登陆密码</template></el-input>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-button type="danger" @click="regist">立 即 注 册</el-button>
        </el-col>
        <el-col :span="12">
          <el-button type="primary" @click="login">立 即 登 陆</el-button>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-popconfirm
            confirm-button-text='确认'
            cancel-button-text='取消'
            @confirm="nologin"
            icon="el-icon-warning"
            icon-color="orange"
            title="未登陆无法使用智能助手,确认不登陆?">
            <el-link style="color:#bababa;font-size:.8rem;" slot="reference">暂 不 登 陆</el-link>
          </el-popconfirm>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
  import { weblogin,loged } from '../../api/api'
  import ElRow from "element-ui/packages/row/src/row";

  export default {
    components: {ElRow},
    name: "IndexLogin",
    data() {
      return {
        browserType: this.$browserType,
        phone:"",
        password:""
      }
    },
    methods: {
      login(){
        if(this.phone == null || this.phone === "" || this.phone.length < 6){
          this.$message.error({showClose:true,duration:3000,message:'请输入正确的手机号'});
        }else if(this.password==null || this.password === ""){
          this.$message.error({showClose:true,duration:3000,message:'请输入登陆密码'});
        }else{
          weblogin(this.phone,this.password).then(res => {
            if(res && res.status === 0){
              loged(res.data);
              this.$router.push("/index/answer");
            }
          })
        }
      },
      regist(){
        this.$router.push("/index/regist");
      },
      nologin(){
        this.$router.push("/");
      }
    }
  }
</script>

<style scoped>
  .index_login {
    position: absolute;
    top:0;
    left:0;
    padding:0;
    margin:0;
    height: 100vh;
    background: #3AA7C2;
    width: 100%;
    background-repeat: no-repeat;
    background-size: cover;
    background-image:url('http://static.anlantech.cn/static/png/background.png');
    overflow:hidden;
    z-index:199;
  }
  .anlan-logo {
    position: absolute;
    top:5vh;
    left:10%;
    width:90%;
    height:20vh;
  }
  .anlan-logo img {
    width:9rem;
  }
  .login_form {
    position: absolute;
    top:20vh;
    width:80%;
    margin: 0 10%;
    padding:0;
    text-align:center;
  }
  .el-col {
    height:7vh;
    line-height:7vh;
    margin-bottom:3vh;
  }
</style>



// WEBPACK FOOTER //
// src/components/index/login.vue